import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide.min.css'; // Import Splide styles

const ProductDetails = () => {
  const products = [
    {
      id: 1,
      image: "/img/WhatsApp Image 2025-09-06 at 7.42.10 PM.jpeg",
      title: "Pneumatic Grease Pumps",
      description: "Efficient and reliable pumps for industrial lubrication."
    },
    {
      id: 2,
      image: "/img/560 BSP.jpg",
      title: "Automatic Grease Feeders",
      description: "Automated grease feeders for smooth machine operation."
    },
    {
      id: 3,
      image: "/img/714B1qgABeS.jpg",
      title: "Double Diaphragm Liquid Transfer Pumps",
      description: "Durable pumps designed for fluid transfer applications."
    },
    {
      id: 4,
      image: "/img/mobile-oil-transfer-system-500x500.webp",
      title: "Oil Transfer Kits",
      description: "Complete kits for quick and easy oil transfers."
    },
    {
      id: 5,
      image: "/img/rotary-barrel-pump-500x500-500x500-500x500.webp",
      title: "Rotary Barrel Pumps",
      description: "Reliable pumps for transferring viscous liquids efficiently."
    },
    {
      id: 6,
      image: "/img/Resize_Aerosol_schema_2.jpg",
      title: "Aerosols",
      description: "High-quality aerosol products for various applications."
    },
    {
      id: 7,
      image: "/img/81iUlkT3WlL._AC_UF1000,1000_QL80_.jpg",
      title: "Grease Guns",
      description: "Efficient and reliable pumps for industrial lubrication."
    },
    {
      id: 8,
      image: "/img/1-2-3-8-Grease-Lubricant-Oil-Automatic-Retractable-Flexible-Hose-Reel.avif",
      title: "Grease/Oil Hose Reels",
      description: "Durable hose reels for easy grease and oil application."
    },
    {
      id: 9,
      image: "/img/trolley-mounted-oil-system.jpg",
      title: "Trolley Mounted Lubrication Kits",
      description: "Convenient kits designed for mobile lubrication systems."
    },
    {
      id: 10,
      image: "/img/cgg3.jpg",
      title: "Battery Powered Grease Guns",
      description: "Battery-powered grease guns for high-efficiency lubrication."
    },
  ];

  const products1 = [
    {
      id: 1,
      image: "/img/WhatsApp Image 2025-09-06 at 7.44.33 PM.jpeg",
      title: "Pneumatic Jacks",
      description: "Efficient pneumatic jacks for heavy-duty lifting tasks."
    },
    {
      id: 2,
      image: "/img/51dbq21tNnL._AC_UF1000,1000_QL80_.jpg",
      title: "Die Grinders",
      description: "Precision die grinders for detailed grinding applications."
    },
    {
      id: 3,
      image: "/img/red-horse-5-inch-angle-grinder-1250-wattt-500x500.webp",
      title: "Angle Grinders",
      description: "Powerful angle grinders for smooth cutting and grinding."
    },
    {
      id: 4,
      image: "/img/71sAodKXcNL.jpg",
      title: "Rivet Guns",
      description: "Durable rivet guns for industrial fastening tasks."
    },
    {
      id: 5,
      image: "/img/cq5dam.web.400.400.jpeg",
      title: "Impact Wrenches",
      description: "High-torque impact wrenches for heavy-duty applications."
    },
    {
      id: 6,
      image: "/img/pneumatic-air-screwdriver-500x500.webp",
      title: "Pneumatic Screwdrivers",
      description: "Efficient pneumatic screwdrivers for fast and precise fastening."
    },
    {
      id: 7,
      image: "/img/WhatsApp Image 2025-09-06 at 7.49.31 PM.jpeg",
      title: "FRLS",
      description: "Flame retardant and low smoke flexible cables."
    },
    {
      id: 8,
      image: "/img/WhatsApp Image 2025-09-06 at 7.52.32 PM.jpeg",
      title: "PU Hoses",
      description: "Flexible polyurethane hoses for diverse industrial uses."
    },
    {
      id: 9,
      image: "/img/pneumatic-fittings.jpg",
      title: "Pneumatic Fittings",
      description: "Durable pneumatic fittings for reliable connections."
    },
    {
      id: 10,
      image: "/img/electromagnetic-flowmeter.jpg",
      title: "Flow Meters",
      description: "Accurate flow meters for precise measurement of fluids."
    },
    {
      id: 11,
      image: "/img/WhatsApp Image 2025-09-06 at 7.53.46 PM.jpeg",
      title: "Air Gun and Accessories",
      description: "Compact air guns and accessories for various tasks."
    },
    {
      id: 12,
      image: "/img/711XduqpX+S.jpg",
      title: "Paint Guns",
      description: "Professional paint guns for smooth, even finishes."
    },
    {
      id: 13,
      image: "/img/WhatsApp Image 2025-09-06 at 7.34.14 PM.jpeg",
      title: "Air Compressors",
      description: "Compact air compressors for portable air supply."
    },
    {
      id: 14,
      image: "/img/41M1OYBahHL._AC_UF1000,1000_QL80_.jpg",
      title: "AODD Pumps",
      description: "Durable AODD pumps for transferring liquids and chemicals."
    },
    {
      id: 15,
      image: "/img/graco-grease-pump.jpg",
      title: "Pneumatic Grease and Oil Pumps",
      description: "Pneumatic pumps for efficient grease and oil handling."
    },
  ];

  const products2 = [
    {
      id: 1,
      image: "/img/exx70-jcb-hydraulic-hose-pipe-500x500.webp",
      title: "Hydraulic Hoses",
      description: "Durable hydraulic hoses for industrial and construction use."
    },
    {
      id: 2,
      image: "/img/WhatsApp Image 2025-09-06 at 7.32.40 PM.jpeg",
      title: "Hydraulic Cylinders",
      description: "High-performance hydraulic cylinders for various applications."
    },
    {
      id: 3,
      image: "/img/hydraulic-fittings.png",
      title: "Hydraulic Fittings",
      description: "Reliable hydraulic fittings for secure and leak-proof connections."
    },
    {
      id: 4,
      image: "/img/31UaL1chXbL._AC_UF1000,1000_QL80_.jpg",
      title: "Hydraulic Power Packs",
      description: "Efficient power packs for hydraulic system applications."
    },
    {
      id: 5,
      image: "/img/hydraulic-press-p60eh1.webp",
      title: "Hydraulic Press",
      description: "Versatile hydraulic presses for industrial pressing operations."
    }
  ];


  return (
    <>
      <div className="container-xxl pt-5">
        <div className="container py-5">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="text-secondary text-uppercase">Our Products</h6>
            <h1 className="mb-5">Explore Our Industrial Products</h1>
          </div>
          <h3 className="product-heading-class">Lubrication Equipment</h3>

          <Splide
            options={{
              type: 'loop',
              perPage: 3,
              perMove: 1,
              gap: '1rem',
              pagination: false,
              autoplay: true,
              interval: 1500,
              breakpoints: {
                640: {
                  perPage: 1,
                },
                768: {
                  perPage: 2,
                },
                1024: {
                  perPage: 3,
                },
              },
            }}
            aria-label="Our Products"
          >
            {products.map((product) => (
              <SplideSlide key={product.id}>
                <div className="service-item p-4">
                  <div className="overflow-hidden mb-4">
                    <img className="img-fluid-service" src={product.image} alt={product.title} />
                  </div>
                  <h4 className="mb-3">{product.title}</h4>
                  <p>{product.description}</p>
                </div>
              </SplideSlide>
            ))}
          </Splide>
        </div>
      </div>
      <div className="container">
        <h3 className="product-heading-class">Pneumatic Equipment</h3>
        <Splide
          options={{
            type: 'loop',
            perPage: 3,
            perMove: 1,
            gap: '1rem',
            pagination: false,
            pagination: false,
            autoplay: true,
            breakpoints: {
              640: {
                perPage: 1,
              },
              768: {
                perPage: 2,
              },
              1024: {
                perPage: 3,
              },
            },
          }}
          aria-label="Our Products"
        >
          {products1.map((product) => (
            <SplideSlide key={product.id}>
              <div className="service-item p-4">
                <div className="overflow-hidden mb-4">
                  <img className="img-fluid-service" src={product.image} alt={product.title} />
                </div>
                <h4 className="mb-3">{product.title}</h4>
                <p>{product.description}</p>
              </div>
            </SplideSlide>
          ))}
        </Splide>
      </div>
      <div className="container">
        <h3 className="product-heading-class">Hydraulic Equipment</h3>
        <Splide
          options={{
            type: 'loop',
            perPage: 3,
            perMove: 1,
            gap: '1rem',
            pagination: false,
            pagination: false,
            autoplay: true,
            breakpoints: {
              640: {
                perPage: 1,
              },
              768: {
                perPage: 2,
              },
              1024: {
                perPage: 3,
              },
            },
          }}
          aria-label="Our Products"
        >
          {products2.map((product) => (
            <SplideSlide key={product.id}>
              <div className="service-item p-4">
                <div className="overflow-hidden mb-4">
                  <img className="img-fluid-service" src={product.image} alt={product.title} />
                </div>
                <h4 className="mb-3">{product.title}</h4>
                <p>{product.description}</p>
              </div>
            </SplideSlide>
          ))}
        </Splide>
      </div>
    </>
  );
};

export default ProductDetails;